import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
import _extends from "@babel/runtime/helpers/esm/extends";
import "antd/es/space/style";
import _Space from "antd/es/space";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "antd/es/spin/style";
import _Spin from "antd/es/spin";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["layout", "renderFormItem", "mode", "render"];
import React, { useContext, useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';
import './index.less';
import { ObjToMap, proFieldParsingText, useFieldFetchData } from '../Select';
/**
 * 多选组件
 *
 * @param param0
 * @param ref
 */

var FieldCheckbox = function FieldCheckbox(_ref, ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'horizontal' : _ref$layout,
      renderFormItem = _ref.renderFormItem,
      mode = _ref.mode,
      render = _ref.render,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var layoutClassName = getPrefixCls('pro-field-checkbox');

  var _useFieldFetchData = useFieldFetchData(rest),
      _useFieldFetchData2 = _slicedToArray(_useFieldFetchData, 3),
      loading = _useFieldFetchData2[0],
      options = _useFieldFetchData2[1],
      _fetchData = _useFieldFetchData2[2];

  var checkBoxRef = useRef();
  useImperativeHandle(ref, function () {
    return _objectSpread(_objectSpread({}, checkBoxRef.current || {}), {}, {
      fetchData: function fetchData() {
        return _fetchData();
      }
    });
  });

  if (loading) {
    return /*#__PURE__*/React.createElement(_Spin, {
      size: "small"
    });
  }

  if (mode === 'read') {
    var optionsValueEnum = (options === null || options === void 0 ? void 0 : options.length) ? options === null || options === void 0 ? void 0 : options.reduce(function (pre, cur) {
      return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, cur.value, cur.label));
    }, {}) : undefined;
    var dom = proFieldParsingText(rest.text, ObjToMap(rest.valueEnum || optionsValueEnum));

    if (render) {
      return render(rest.text, _objectSpread({
        mode: mode
      }, rest.fieldProps), /*#__PURE__*/React.createElement(React.Fragment, null, dom)) || null;
    }

    return /*#__PURE__*/React.createElement(_Space, null, dom);
  }

  if (mode === 'edit') {
    var _rest$fieldProps;

    var _dom = /*#__PURE__*/React.createElement(_Checkbox.Group, _extends({}, rest.fieldProps, {
      className: classNames((_rest$fieldProps = rest.fieldProps) === null || _rest$fieldProps === void 0 ? void 0 : _rest$fieldProps.className, "".concat(layoutClassName, "-").concat(layout)),
      options: options
    }));

    if (renderFormItem) {
      return renderFormItem(rest.text, _objectSpread({
        mode: mode
      }, rest.fieldProps), _dom) || null;
    }

    return _dom;
  }

  return null;
};

export default /*#__PURE__*/React.forwardRef(FieldCheckbox);